




















































































































import { Component, Vue } from 'vue-property-decorator';
import ResponsibleTodos from '@/components/Responsibles/ResponsibleTodos.vue';
import EditableResponsible from '@/components/Responsibles/EditableResponsible.vue';
import SaveButton from '@/components/App/SaveButton.vue';
import axios from 'axios';
import { Company } from '@/types';
import { Responsible } from '@/interfaces/Responsible';
import env from '../env';

@Component({
  components: {
    SaveButton,
    ResponsibleTodos,
    EditableResponsible
  }
})
export default class ResponsiblesView extends Vue {
  dialog = false;

  private responsibleToAdd: Partial<Responsible> = {
    name: '',
    company_id: null,
    description: '',
    department: '',
    email: '',
    phone: '',
    abbreviation: '',
    cutover_communication: false
  };

  private companies: Company[] = [];

  private new_role_name = '';

  async addResponsible() {
    await axios.post(`${env.backend_url}/responsible/create`, this.responsibleToAdd);
    this.$store.state.all_responsibles.push(this.responsibleToAdd);

    this.responsibleToAdd = {
      name: '',
      company_id: null,
      description: '',
      department: '',
      email: '',
      phone: '',
      abbreviation: '',
      cutover_communication: false
    };

    return true;
  }

  async addRole() {
    await axios.post(`${env.backend_url}/role/create`, { name: this.new_role_name });
    this.new_role_name = '';
  }

  goToNewPerson() {
    const scrollTo = document.getElementById('newPerson');
    if (scrollTo) this.$vuetify.goTo(scrollTo);
  }

  saveResponsible() {
    const promises = [];
    for (const responsible of this.$store.state.all_responsibles) {
      promises.push(
        axios.post(`${env.backend_url}/responsible/update/${responsible.id}`, responsible)
      );
    }
    return Promise.all(promises);
  }

  async created() {
    this.$emit('showPreloader');
    this.$store.dispatch('refreshData');
    const { data: companies } = await axios.get(`${env.backend_url}/all_companies`);
    this.companies = companies;
    this.$emit('loadingFinished');
  }
}
